<template>
  <p @click="handleClick" class="ma-0 link" :class="classes">
    <slot></slot>
  </p>
</template>
<script>
export default {
  name: "BtnLink",

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  computed: {
    classes() {
      return {
        "primary--text": !this.disabled,
        "secondary-text--text": this.disabled
      };
    }
  },

  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
.link {
  cursor: pointer;
}
</style>
